export default __webpack_public_path__ + "static/media/3.03ba4895.jpg";